var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "OfflineRequestArchives" } },
    [
      _c("ArchiveComponent", {
        attrs: {
          "fetch-callback": _vm.getOfflineSupportRequests,
          "is-archive": false,
          "selected-time": _vm.timeSelect,
          "table-data": _vm.offlineSupportRequests.data,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }